module.exports = __webpack_public_path__ + "img/Terri Collins.095a2195.jpg";